import { createContext } from "react";

export interface IFeedbackContext {
  openFeedback: () => void;
}

export const FeedbackContext = createContext<IFeedbackContext | null>(null);
